import * as z from 'zod';

import { nullableNumericMutationSchema } from '@/_schemas/generic';

import { marketingCampaignQuerySchema } from './marketing-campaigns-query-schema';

export const marketingCampaignMutationSchema = marketingCampaignQuerySchema
  .omit({
    clients: true,
    contacts: true,
    contacts_count: true,
  })
  .extend({
    contacts: z.array(z.number()),
    clients: z.array(z.number()),
    total_cost_of_campaign: nullableNumericMutationSchema(),
    attached_files: z.array(z.number()),
  });

export type MarketingCampaignMutationSchema = z.infer<typeof marketingCampaignMutationSchema>;

export const marketingCampaignCreateSchema = marketingCampaignMutationSchema.omit({
  id: true,
});

export type MarketingCampaignCreateSchema = z.infer<typeof marketingCampaignCreateSchema>;
